var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCapsule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.91896C4 8.21573 4.46489 7.5125 5.40876 6.97102C7.27537 5.89508 10.3007 5.89508 12.1638 6.97102C13.0971 7.50899 13.5725 8.21222 13.5725 8.91896",
    stroke: "#B7B7B7",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.03418,
    y: 1.59961,
    width: 9.71614,
    height: 14.5742,
    rx: 4.85807,
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6986 8.91797C13.6986 9.6212 13.2302 10.3244 12.2899 10.8624C10.4268 11.9383 7.40147 11.9383 5.53486 10.8624C4.60156 10.3244 4.1261 9.6212 4.1261 8.91797",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCapsule);
export default __webpack_public_path__ + "static/media/ic_capsule.5ecebe46b15e073d4eb40140db7d3175.svg";
export { ForwardRef as ReactComponent };